// extracted by mini-css-extract-plugin
export default {"info":"OrgsFilterInfo_info__c89pH","placeHolderShimmer":"OrgsFilterInfo_placeHolderShimmer__T1l+i"};